import { useState, useCallback, useEffect } from 'react';

export function useWidth(elementRef, deps = [], delay = 250) {
  const [width, setWidth] = useState(null);

  const updateWidth = useCallback(() => {
    if (elementRef && elementRef.current) {
      const { width } = elementRef.current.getBoundingClientRect();
      setWidth(width);
    }
  }, [elementRef]);

  useEffect(() => {
    setTimeout(() => {
      updateWidth();
    }, delay);
    // eslint-disable-next-line
  }, [...deps, delay]);

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, [updateWidth]);

  return [width];
}
